// Global var tracks whether map is being touched
var touchingMap = false;

// When the Mapbox canvas is touched, adjust the global tracking var
$(document).on("touchstart", ".mapboxgl-map", function (e) {
  touchingMap = true;
});

// When the Mapbox canvas is no longer being touched, adjust the global tracking var
$(document).on("touchend", ".mapboxgl-map", function (e) {
  if (e.touches.length == 0) {
    touchingMap = false;
  }
});

// When any touch move event happens fire this:
$("*").on("touchmove", function (e) {
  // If the map is currently being touched, block any touch move event except those coming from the map.
  if (touchingMap && !($(this).prop("tagName").toLowerCase() == ".mapboxgl-map")) {
    e.preventDefault();
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/map-scrolling.js